import script from "./ConsoleLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleLayout.vue?vue&type=script&setup=true&lang=js"

import "@/styles/console.css?vue&type=style&index=0&lang=css&external"
import "./ConsoleLayout.vue?vue&type=style&index=1&id=18124b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18124b4c"]])

export default __exports__